module.exports = __webpack_public_path__ + "images/patterns/dark/DotsChecker.0d2a347a86e555fbe19d.svg";